import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RoleBasedRedirect = () => {
  const { user } = useSelector((state) => state.auth);

  // Role-based redirection logic based on backend structure
  const getRedirectPath = (roleId) => {
    switch (roleId) {
      case 1: // Super Admin
        return '/practices';
      case 2: // Admin
        return '/practices';
      case 3: // Practice Admin
        return user?.practice_id ? `/practices/${user.practice_id}` : '/practices';
      case 4: // Provider
        return '/provider-dashboard';
      case 5: // Practice Caregiver
        return '/caregiver-dashboard';
      case 6: // Patient
        return '/patient-dashboard';
      // System Caregiver disabled
      // case 7: // System Caregiver
      //   return '/system-caregiver-dashboard';
      default:
        return '/practices';
    }
  };

  if (!user || !user.role_id) {
    return <Navigate to="/login" replace />;
  }

  const redirectPath = getRedirectPath(user.role_id);
  return <Navigate to={redirectPath} replace />;
};

export default RoleBasedRedirect;
